import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  addCalendarEventData: null,
  addCalendarEventDataSuccess: false,
};

const slice = createSlice({
  name: "addCalendarEvent",
  initialState: initialState,
  reducers: {
    addCalendarEventData: (state, action) => {
      state.loading = true;
      state.error = null;
      state.addCalendarEventData = null;
      state.addCalendarEventDataSuccess = false;
    },
    addCalendarEventDataSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.addCalendarEventData = action.payload;
      state.addCalendarEventDataSuccess = true;
    },
    addCalendarEventDataError: (state, action) => {
      state.error = action.payload;
      state.addCalendarEventData = null;
      state.loading = false;
      state.addCalendarEventDataSuccess = false;
    },
    addCalendarEventResetState: () => initialState,
  },
});

export const {
  addCalendarEventData,
  addCalendarEventDataSuccess,
  addCalendarEventDataError,
  addCalendarEventResetState,
} = slice.actions;

export default slice.reducer;
